import { Component, inject, OnInit } from "@angular/core";

import { PATHS } from "@shared/resources/paths.constants";

import { AppConfig } from "../app.config";

@Component({
  selector: "page-not-found",
  imports: [],
  templateUrl: "./page-not-found.component.html",
  styleUrl: "./page-not-found.component.scss"
})
export class PageNotFoundComponent implements OnInit {
  plantsHelpUrl: string;
  appConfig = inject(AppConfig);

  ngOnInit(): void {
    this.plantsHelpUrl = this.appConfig.getPlantsUrl() + PATHS.PLANTS_HELP_PDF_2022;
  }
}
